import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import bezier from 'bezier-easing'
import scale from '../components/scale'
import _each from 'lodash.foreach'
import gsap from 'gsap'



class Page extends Component {

  constructor(element) {

    super(element)

    this.ease = bezier(.48,0,.12,1);
    this.ease2 = bezier(.25,.46,.45,.94);

    this.body = $('body')
    this.html = $('html')
    this.element = element
    this.el = $(element)

    this.ref = {
      vm: []
    }

  }

  mount() {


      this.top = 0
      this.diff = 0


      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);
      this.renderQue = this.render.bind(this)
      stage.on("stage:scroll", this.renderQue);
    //  this.pr = document.getElementById('pr')
      // $('.pr').on("scroll", this.renderQue);
    //  this.pr.addEventListener('scroll', this.renderQue)
      this.resize(stage);


  }


  resize(e){
      this.render(e)
  }

  render(e){

    const box = this.element.getBoundingClientRect()
    this.diff = -this.top + box.top
    this.top = box.top
    const menuOut = this.diff < 0 && -this.top > 90
    const headerend = -box.top >= stage.h


    _each(this.ref.vm, (el)=>{
      const img = el.getBoundingClientRect();
      $(el).toggleClass('inview', img.top < stage.h)
    })

    //this.body.toggleClass('menu-out', menuOut)

  }


  unmount() {

    stage.removeListener("stage:resize", this.resizeQue);
    stage.removeListener("stage:scroll", this.renderQue);

  }

}

module.exports = Page
